import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from './__root'
import {
  beforeLoadProtectedWebviewSession,
  loadProtectedWebviewSession,
  retryWebviewAuthOrCloseApp,
} from './protectedWebviewSession'
import { prefetchFloor6MapRoute } from './floor6Map'
import { Button } from 'shared/ui/Button'

export const webviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/webview',
  errorComponent: ({ error }) => {
    const message = error instanceof Error ? error.message : 'Не удалось открыть карту'

    return (
      <div className="p-5 h-dvh w-full grid place-items-center">
        <div className="flex flex-col items-center gap-3">
          <div className="text-red-600 text-center">{message}</div>
          <Button onClick={retryWebviewAuthOrCloseApp}>Повторить</Button>
        </div>
      </div>
    )
  },
  beforeLoad: beforeLoadProtectedWebviewSession,
  loader: async () => {
    prefetchFloor6MapRoute()
    await loadProtectedWebviewSession()
    throw redirect({ to: '/floor-6/map/$block', params: { block: 'full' } })
  },
})
